import axios from "axios";
import store from "../redux/Store";
import { LogoutUser } from "../redux/actions/Auth.Action";

var ApiConnect = axios.create({
  baseURL: `https://${process.env.REACT_APP_API_URL}/`,
  responseType: "json",
  headers: {
    Authorization: process.env.REACT_APP_API_KEY,
    Company: process.env.REACT_APP_COMPANY,
    Theme: process.env.REACT_APP_THEME,
  },
});
ApiConnect.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    var selector = store.getState();
    config.headers.Token = selector.Auth.Token || "";
    config.headers.UserID = selector.Auth.userData.user_id || "";
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

const UNAUTHORIZED = 401;
const { dispatch } = store; // direct access to redux store.
const unAuthInter = ApiConnect.interceptors.response.use(
  (response) => response,
  (error) => {
    const { status } = error.response;
    if (status === UNAUTHORIZED) {
      dispatch(LogoutUser());
    }
    return () => {
      ApiConnect.interceptors.response.eject(unAuthInter)
    }
  }
);

export default ApiConnect;
